<template>
    <div>
      <contact-type-list></contact-type-list>
    </div>
  </template>
  
  <script>
  export default {
  }
  </script>
  